<template>
  <div class="banner">
    <div v-if="Data" class="con">
      <h1>企业学习中心</h1>
      <p><span>参训者：{{Data.pxrXm}}</span><span>身份证：{{Data.pxrSfz}}</span><span>已学学时：{{Data.xxglYxxs}}</span></p>
      <!-- <a v-if="Data.ksCj < 85 || !Data.ksCj" href="/module/exam.html" target="_blank" class="qks">去考试</a> -->
      <router-link v-if="(Data.xxglYxxs-0.001 >= Data.totalPxTime) && (Data.ksCj < 85 || !Data.ksCj)" :to="{path: '/exam',query:{lxId:lxId}}" target="_blank" class="qks">去考试</router-link>
      <a v-if="Data.ksCj >= 85" @click="downs(6)" class="qks">预览培训证明</a>
      <!--<a href="" target="_blank" class="qks">预览信用报告</a>-->
      <div v-if="Data.ksCj != null" class="qks" @click="dialogVisible = true">查看成绩单</div>
      <div class="cj" style="right: 140px">
        <p>考试成绩</p>
        <p v-if="Data.ksCj != null">{{Data.ksCj}}</p>
        <p v-else>--</p>
      </div>
      <div class="cj">
        <p>补考次数</p>
        <p>{{Data.xxglBkcs}}</p>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      top="5vh"
      width="1000px">
      <cjd :cj="Data"></cjd>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { cookie } from "@/common/js/cookies.js";
  import  cjd from '@/components/exam/cjd'
  export default {
    name: "banner",
    data() {
      return {
        Data: null,
        dialogVisible : false,
      }
    },
    mounted() {
      this.lxId = this.$route.query.lxId;
      this.getData();
    },
    methods: {
      getData: function () {
        let _self = this;
        let ajax = _self.$http.create();
        let data = {
          lxId:this.lxId
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/getEnterpriseCenter',
          data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
        }).then(function (json) {
          if (json.data.result == 1) {
            _self.Data = json.data.data;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
            if(json.data.result == 2){
              setTimeout(()=>{
                //登录失效删除token
                cookie.delete('xyxf_token_qt');
                window.location.href = SOWINURL + 'index/login';
              },2000);
            }
          }
          loading.close();

        }).catch(function (error) {
          console.log(error);
        });
      },
			//预览培训证明
			downs(type){
			  let _self = this;
			  let ajax = _self.$http.create();
				const loading = this.$loading({
				  lock: true,
				  text: 'Loading',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
			  ajax({
				method: "post",
				url: SOWINURL + "report/getQyfj",
				data:{
					qyId: _self.qyId,
					fjType: type
				},
				headers:{
					'token': cookie.get("xyxf_token_qt")
				}
			  })
			  .then(function(json) {
				  _self.download(json.data.data)
				  loading.close();
			  })
			  .catch(function(error) {
					loading.close();
				console.log(error);
			  })
			},
			download (data) {
			        if (!data) {
			            return
			        }
			        let url = data;
			        let link = document.createElement('a')
			        link.style.display = 'none'
			        link.href = url
			        link.setAttribute('download', '')
					link.setAttribute('target', '_blank')

			        document.body.appendChild(link)
			        link.click()
			},
    },
    components: {
      cjd
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .banner {
    width: 100%;
    background: url("/static/images/center_banner.png") no-repeat center;
    background-size: cover;
    padding-top: 36px;
    height: 205px;

    .con {
      width: 1210px;
      margin: 0 auto;
      color: #fff;

      h1 {
        height: 66px;
        line-height: 66px;
        font-size: 36px;
      }

      p {
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        margin-bottom: 8px;

        span {
          padding-right: 40px;
        }
      }
    }

    .qks {
      display: inline-block;
      /*width: 100px;*/
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      margin-right: 20px;
      background: -webkit-linear-gradient(left, #0076ff, #00c9ff); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(right, #0076ff, #00c9ff); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(right, #0076ff, #00c9ff); /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
      border-radius: 20px;
      font-weight: normal;
      cursor: pointer;
      padding: 0 20px;
    }
    .no-qks{
      background: #ccc; /* Safari 5.1 - 6.0 */
      background: #ccc; /* Opera 11.1 - 12.0 */
      background: #ccc; /* Firefox 3.6 - 15 */
      background: #ccc; /* 标准的语法 */
    }
    .cj {
      position: absolute;
      right: 0;
      top: 20px;

      p {
        color: #fff;
        height: 30px;
        line-height: 30px;
        width: 94px;
        text-align: center;
        font-size: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/center/banner.vue